var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"m-auto nav-item",attrs:{"to":'/Mes-Invitations'}},[_c('i',{staticClass:"ti-bell ti-Icon"},[_c('Nb-Invitation',{attrs:{"page":"header-notifications"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }